// 二次确认按钮
import * as React from "react";
import { Button, Modal, message } from "antd";
import { WordWrapProperty, TextAlignProperty } from "csstype";

interface IButtonSecondaryProps {
  ids: any;
  // 要提交的参数名称
  field?: any;
  buttonText: any;
  buttonStyle?: any;
  buttonSize?: any;
  modalTitle?: any;
  modalText: any;
  // 警告文案
  warningText?: any;
  // 成功文案
  successText?: any;
  // 提交
  submit: any;
  // 回调
  cb?: any;
}

// 二次确认按钮
class ButtonSecondary extends React.Component<IButtonSecondaryProps, any> {
  state = { visible: false, value: "", disabled: false, isRequest: false };

  constructor(props: IButtonSecondaryProps) {
    super(props);
  }

  showModal = () => {
    if (this.props.ids.length > 0) {
      this.setState({
        visible: true
      });
    } else {
      message.config({
        top: 100,
        duration: 2,
        maxCount: 1
      });
      message.warning(this.props.warningText || "请选择订单");
    }
  };

  handleOk = e => {
    this.setState(
      {
        isRequest: true
      },
      () => {
        const param = {};
        const ids = this.props.field || "ids";
        param[ids] = this.props.ids;

        this.props.submit({
          ...param,
          callback: data => {
            if (data && data.error) {
              message.error(data.res.msg);
              this.setState({
                isRequest: false
              });
            } else {
              this.setState({
                visible: false,
                isRequest: false
              });
              message.success(this.props.successText || "批量发货成功");
              this.props.cb && this.props.cb();
            }
          }
        });
      }
    );
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
      value: "",
      disabled: true,
      isRequest: false
    });
  };

  bodyStyle = {
    padding: "24px",
    fontSize: "14px",
    lineHeight: "98px",
    minHeight: "140px",
    wordWrap: "break-word" as WordWrapProperty,
    textAlign: "center" as TextAlignProperty
  };

  render() {
    const buttonStyle = this.props.buttonStyle || {
      backgroundColor: "#2b9fbd",
      borderColor: "#2b9fbd"
    };
    return (
      <div className="button-group-child">
        <Button
          type="primary"
          style={buttonStyle}
          size={this.props.buttonSize || "default"}
          onClick={this.showModal}
        >
          {this.props.buttonText}
        </Button>
        <Modal
          title={this.props.modalTitle || "提示"}
          bodyStyle={this.bodyStyle}
          centered={true}
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          {this.props.modalText}
        </Modal>
      </div>
    );
  }
}

export default ButtonSecondary;
